import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-the-page-ab01 c-common-footer-fixed" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"c-common-footer-fixed__inner\" data-v-c83dc42c><div class=\"c-common-inner\" data-v-c83dc42c><main class=\"p-the-page-ab01__loginpanel\" data-v-c83dc42c><div class=\"p-the-page-ab01__loginpanel__inner\" data-v-c83dc42c><div class=\"p-the-page-ab01__service_logo__wrap\" data-v-c83dc42c><p data-v-c83dc42c>当該サービスは現在ご利用いただけません。</p></div></div></main></div></div>", 1)),
    _createVNode(_component_TheFooter)
  ]))
}